import { IonCard, IonCardHeader, IonCardTitle, IonListHeader, IonButton, IonButtons, IonContent, IonHeader, IonImg, IonItem, IonLabel, IonList, IonTitle,  IonToolbar, IonicSlides } from '@ionic/react';
import React, {  useState } from 'react';
import { IonIcon } from '@ionic/react';
import { alarmSharp, callSharp, cellularSharp, desktopSharp, linkSharp, logoFacebook, logoInstagram, logoPinterest, logoSnapchat, logoTiktok, logoTwitter, logoWhatsapp, logoYoutube, mailSharp, mapSharp, medalSharp,} from 'ionicons/icons';
import { PlatilloQRooProps, TurComProps } from '../interfaces';

// import required modules

import closePage from '../assets/close-circle.svg'
import location_white from '../assets/location-pin.svg'


//Estilos de cada carta
import './SabYucatanModal.css'

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/controller'
import { Autoplay, Keyboard, Pagination, Scrollbar, Zoom } from 'swiper';

import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/keyboard';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/zoom';
import '@ionic/react/css/ionic-swiper.css';


const PlatilloQRooModal = ({
    marker,
    onDismiss,
  }: {
    marker : PlatilloQRooProps;
    onDismiss: () => void;
  }) => {
  
    return (
        <>
        <IonHeader className='art-ion-header'>
            <IonToolbar className='name-header-modal1 toolbar-modal-tour'>
                <IonButtons className='button-close'>
                    <IonButton className='text-close-tour' onClick={() => onDismiss()}>
                        <img src={closePage} alt="imageClose" id='icon-close' />
                    </IonButton>
                </IonButtons>
                <IonImg className='header-modal-img-tour'
                    src={marker.imagenPlatillo[0]}
                    alt={marker.nombrePlatillo}
                >                    
                </IonImg>
                <IonTitle>
                    <div className="open">
                            {marker.nombrePlatillo}<br/>
                    </div>
                </IonTitle>
            </IonToolbar>
        </IonHeader>
        
        <IonContent fullscreen={true} className="ion-padding">
        
            <div className="open">
                <h5>{marker.nombrePlatillo}</h5>
                {marker.localidad}, {marker.estado}
            </div>
            <IonList>
                <IonItem>
                <p>{marker.descripcion}</p>
                </IonItem>
            </IonList>
            <Swiper
                // spaceBetween={5}
                modules={[Autoplay, Keyboard, Pagination, Scrollbar, Zoom, IonicSlides]}
                autoplay={true}
                keyboard={true}
                pagination={{
                  dynamicBullets: true,
                }}
                scrollbar={true}
                zoom={true}
                slidesPerView={1}
                onSlideChange={() => console.log('slide change')}
                onSwiper={(swiper) => console.log(swiper)}
              >
              {marker.imagenesIngredientes.map((element, index) => 
            <>
              <SwiperSlide>
                <IonCard id='swiper-ioncard'>
                <img className="img-swiper" alt='Hola' src={element} />
                  <IonCardHeader>
                    <IonCardTitle>{marker.ingredientes[index]}</IonCardTitle>
                  </IonCardHeader>
                </IonCard>
              </SwiperSlide>
                </>
              )
              }
              </Swiper>

        <IonList className='Incluye padd-incluye'>
          <IonListHeader>
            <IonLabel className='title-incluye'>Preparación</IonLabel>
          </IonListHeader>
          {marker.procedimiento.map((element, index) => 
            <>
                <IonItem className="open">
                  <h5>{marker.procedimiento[index]}</h5>
                </IonItem>
            </>
          )
        }
          
        </IonList>

        </IonContent>
        </>
    );
};

export default PlatilloQRooModal;